import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { images } from '../constants/images';

const TESTIMONIAL_VIDEO_URL =
  'https://pub-3acbfdb36a6a4a758770a8294a62150d.r2.dev/KS%20Testimonials%20compressed.mp4';

export const Kumbh2019Section: React.FC = () => {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const onClickPlay = useCallback(() => {
    setPlaying(true);
    setTimeout(() => {
      videoRef.current?.play();
    }, 100);
  }, []);

  const { t } = useTranslation(['home', 'common']);

  return (
    <section
      id="2025"
      className="py-20 md:py-28 bg-gradient-to-b from-green-100 via-white to-emerald-50"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            10,000+ Guests Hosted
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-display text-emerald-900 mb-4">
            Memories from Magh Mela 2026
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            {t('home:2019.guests')}
          </p>
        </div>

        {/* Video Section */}
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            {playing ? (
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <video
                  ref={videoRef}
                  className="absolute inset-0 w-full h-full object-cover"
                  src={TESTIMONIAL_VIDEO_URL}
                  controls
                  controlsList="nodownload"
                  autoPlay
                  playsInline
                />
              </div>
            ) : (
              <div
                className="relative w-full cursor-pointer group"
                style={{ paddingBottom: '56.25%' }}
                onClick={onClickPlay}
              >
                <img
                  className="absolute inset-0 w-full h-full object-cover"
                  src={images['yajna']}
                  alt="Testimonial montage thumbnail"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

                {/* Play Button */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform group-hover:scale-110 transition-transform">
                  <div className="w-16 h-16 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl">
                    <svg
                      className="w-6 h-6 ml-0.5 text-gray-800"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <polygon points="6,4 20,12 6,20" />
                    </svg>
                  </div>
                </div>

                {/* Title Overlay */}
                <div className="absolute bottom-8 left-0 right-0 text-center px-6">
                  <p className="font-display font-bold text-2xl md:text-3xl text-white mb-2">
                    Testimonial Montage
                  </p>
                  <p className="text-white/80 text-sm md:text-base">
                    Hear from our visitors
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
